import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { router } from './router';
import { QueryProvider } from './providers/QueryProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { SmoothScrollProvider } from './providers/SmoothScrollProvider';

export function App() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <SmoothScrollProvider>
          <RouterProvider router={router} />
          <Toaster
            position="top-center"
            theme="system"
            visibleToasts={4}
            offset={84}
            gap={10}
            toastOptions={{
              duration: 4500,
              unstyled: true,
              className: 'uo-toast',
              classNames: {
                toast: 'uo-toast',
                title: 'uo-toast-title',
                description: 'uo-toast-desc',
                actionButton: 'uo-toast-action',
                cancelButton: 'uo-toast-cancel',
                closeButton: 'uo-toast-close',
                icon: 'uo-toast-icon',
              },
            }}
          />
        </SmoothScrollProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
